// ============== imports ==================
import './index.css'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css';
import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { EXRLoader } from 'three/examples/jsm/loaders/EXRLoader.js';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js';
import {Raycaster} from "three";
// ============ END imports ================

// ============== constant ==================
const API_BASE_URL = localStorage.getItem('API_BASE_URL') || '/api';
const MODEL_LIST_LINK = API_BASE_URL + '/model-list'; // link to get the list of all available models
const MODEL_FILES_LINK = API_BASE_URL + '/uploads?id='; // get the files of a specific model
const MODEL_PATH = "/models/"; // the local path to the model files
const HEADERS = {'Access-Control-Allow-Origin':'*'}; // headers for all requests to the api

const DRACO_LOADER = new DRACOLoader(); // handles decompressing of 3D meshes
const GLTF_LOADER = new GLTFLoader(); // create GLTF loader
const HDR_LOADER = new RGBELoader(); // create HDR loader
const EXR_LOADER = new EXRLoader(); // create EXR loader

const MARKER_UNSELECT_COLOR = 0x94b3fd;
// ============ END constant ================

// ============== init Three.js ==================
const canvas = document.querySelector('canvas.webgl'); // get the canvas to put the scene
const scene = new THREE.Scene(); // create the scene

// create a floor
const planeW = 50; // pixels
const planeH = 50; // pixels
const numW = 50; // how many wide (50*50 = 2500 pixels wide)
const numH = 50; // how many tall (50*50 = 2500 pixels tall)
const floor = new THREE.Mesh(
    new THREE.PlaneGeometry( planeW*numW, planeH*numH, planeW, planeH ),
    new THREE.MeshBasicMaterial( {
        color: 0xffffff,
        wireframe: true
    } )
);
floor.rotation.x = -Math.PI * 0.5;
floor.name = "floor";
scene.add(floor);

// add a general light to the scene
const hlight = new THREE.AmbientLight (0x404040,5);
scene.add(hlight);

// var to hold the size of the screen
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}
// add event to resize the scene when the window of the browser changes size
window.addEventListener('resize', () => {
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight
    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()
    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
});
// ============ END init Three.js ================

// ============== get models ================
/**
 * send a request to the API to get the 3D model's names available.
 * also put each name in the dropdown box to select the first model
 */
function getModelList(){
    // find dropdown box
    var select = document.getElementById("model-list");
    // remove previous choices, if any
    var i, L = select.options.length - 1;
    for(i = L; i >= 0; i--) {
        select.remove(i);
    }
    // send request to API
    fetch(MODEL_LIST_LINK, {
        method: "GET",
        mode: 'cors',
        headers: HEADERS,
    }).then(async (response) => {
        // request is successful
        var data = await response.text();
        data = JSON.parse(data); // transform the data received
        for (let i = 0; i < data.length; i++) {
            // for each name, create an option for dropdown box
            const opt = document.createElement("option");
            opt.value = data[i];
            opt.text = data[i];
            select.add(opt, null);
        }
    });
}
getModelList(); // launch the request when loading
// add click listeners to dropdown box to load the model
document.getElementById("load-btn").onclick = function() {
    loadModel(document.getElementById("model-list"))
};
// ============ END get models ==============

// ============== load models ================
DRACO_LOADER.setDecoderPath('/draco/');
GLTF_LOADER.setDRACOLoader(DRACO_LOADER); // tell the GLTF loader to use DRACO

let currentModel; // var to store the current model to apply modifications
/**
 * get the files linked to a model and search for the model file (.gtlf, .hdr, .exr).
 * load the model and add it to the scene + gui
 * @param modelSelector the dropdown box with the model name selected
 */
function loadModel(modelSelector){
    var modelName = modelSelector.value; // get the name of the model from the dropdown box
    // send request to server to get the files of the model
    fetch(MODEL_FILES_LINK+modelName, {
        method: "GET",
        mode: 'cors',
        headers: HEADERS,
    }).then(async (response) => {
        // request is successful --> decode response
        const data = await response.text();
        var fileList = JSON.parse(data); // the list of files concerning the model
        // iterate through all the files to check for a GLTF, HDR or EXR file
        for (let i = 0; i < fileList.length; i++) {
            var file = fileList[i];
            console.log(file);
            if(file.endsWith(".gltf")){
                // we found the model file as GLTF format --> load the model
                GLTF_LOADER.load(MODEL_PATH+modelName+"/"+file, (gltf) => {
                    // loading done
                    addModelToScene(gltf.scene, modelName);
                }, (xhr) => {
                    // progression
                    console.log("Loading : " + ( xhr.loaded / xhr.total * 100 ) + '%');
                }, (error) => {
                    // on error
                    console.log(error);
                });
            }else if(file.endsWith(".exr")){
                // we found the model file as EXR format --> load model
                EXR_LOADER.load( MODEL_PATH+modelName+"/"+file, ( texture, textureData ) => {
                    const material = new THREE.MeshBasicMaterial( { map: texture } );
                    const quad = new THREE.PlaneGeometry( 1.5 * textureData.width / textureData.height, 1.5 );
                    const mesh = new THREE.Mesh( quad, material );
                    addModelToScene(mesh, modelName);
                }, (xhr) => {
                    // progression
                    console.log("Loading : " + ( xhr.loaded / xhr.total * 100 ) + '%');
                }, (error) => {
                    // on error
                    console.log(error);
                });
            }else if(file.endsWith(".hdr")){
                // we found the model file as HDR format --> load model
                HDR_LOADER.load( MODEL_PATH+modelName+"/"+file, function ( texture, textureData ) {
                    const material = new THREE.MeshBasicMaterial( { map: texture } );
                    const quad = new THREE.PlaneGeometry( 1.5 * textureData.width / textureData.height, 1.5 );
                    const mesh = new THREE.Mesh( quad, material );
                    addModelToScene(mesh, modelName);
                }, (xhr) => {
                    // progression
                    console.log("Loading : " + ( xhr.loaded / xhr.total * 100 ) + '%');
                }, (error) => {
                    // on error
                    console.log(error);
                });
            }
        }

        var x = document.getElementById("snackbar-import");
        x.className = "show";
        setTimeout(function(){ x.className = x.className.replace("show", ""); }, 3000);
    });
}

/**
 * add a model to the scene. Also check for a config file
 * @param model the model to add to the scene
 * @param modelName the name of the model we're adding to the scene
 */
function addModelToScene(model, modelName){
    // add the model to the scene
    currentModel = model;
    currentModel.scale.set(0.5,0.5,0.5);
    scene.add(currentModel);
    currentModel.position.set(camera.position.x, 0.5, camera.position.z);
    // show the scene to the user
    document.getElementById("blocker").setAttribute("style", "display: none;");
    checkForConfig(modelName); // need to check a config file
    // show success toast to user
    const toast = document.getElementById("snackbar-import");
    toast.className = "show";
    setTimeout(function(){ toast.className = toast.className.replace("show", ""); }, 3000);
}

/**
 * search for a config file of a specific model.
 * it's possible that the request fails if there is no file (first time loading the model for example)
 * @param modelName the name of the model we need to find a config file for
 */
function checkForConfig(modelName){
    // search the config file locally
    fetch(MODEL_PATH + modelName + "/config.json").then(response => response.json()).then(json => {
        // config file found
        json = JSON.parse(json);
        // handles the scene parameters
        // light
        let light = json.params.light;
        hlight.intensity = light;
        // scale
        const scale = json.params.scale;
        currentModel.scale.set(scale, scale, scale);
        // speed
        const speed = json.params.speed;
        moveDistance = speed * 0.2;
        // rotation
        const rotation = json.params.rotation;
        rotateAngle = Math.PI / 2 * (rotation / 100);
        // marker
        const marker = json.params.marker;
        marker_r = marker;
        // position
        const position = json.params.position;
        currentModel.position.set(currentModel.position.x, position, currentModel.position.z);
        // markers
        const markersList = json.markers;
        // iterate through all the markers
        for (let i = 0; i < markersList.length; i++) {
            // create the marker in the scene and GUI
            createMarker(markersList[i], i);
        }
        teleport(0); // teleport the camera to the first marker
    })/*.catch(function() {
        // request failed
        console.log('Config file not found');
    });*/
}
// ============ END load models ==============

// ============== marker handling ================
let marker_r = 20; // rayon of the marker
let markers = []; // the list of markers
let currentMarkerId = -1; // the current id of the marker

/**
 * add a marker at a specific position in the scene and in the GUI
 * @param position the position in the scene where to add the marker
 */
function createMarker(position, id){
    const geometry = new THREE.CircleGeometry(marker_r, 32);
    const material = new THREE.MeshBasicMaterial({color: MARKER_UNSELECT_COLOR});
    const circle = new THREE.Mesh(geometry, material);
    circle.rotation.x = 11;
    circle.position.x = position.x;
    circle.position.y = position.y;
    circle.position.z = position.z;
    circle.name = "marker"+id;
    scene.add(circle);
    // add object to array as storage
    markers.push(circle);
    // add button in GUI
    const markerGUI = document.getElementById("markers-content");
    markerGUI.innerHTML += "<div id=\"marker-selector-" + id + "\"><input type=\"radio\" class=\"btn-check\" id=\"marker-check-" + id + "\" " +
        "autocomplete=\"off\" name=\"options-outlined\" value=\"" + id + "\">\n" +
        "<label class=\"btn btn-outline-primary\" for=\"marker-check-" + id + "\">Marker " + id + "</label></br></br></div>";
    // add event on button
    for (let i = 0; i < id + 1; i++) {
        const radioBtn = document.getElementById("marker-check-" + i);
        if (radioBtn !== null) {
            radioBtn.addEventListener('change', function () {
                doTeleportation(this.value)
            });
        }
    }
}
// ============ END load models ==============

// ============== controls system ================

// Base camera
//create the perspective camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 500000);
camera.position.set(2, 2, 2); // set the camera initial position
camera.rotation.order = "YXZ"; // set the rotation order --> used to prevent weird behavior
scene.add(camera); // add the camera to the scene

// var to know if a keyboard key is currently pressed
var isRotateLeft = false;
var isRotateRight = false;
var isRotateUp = false;
var isRotateDown = false;
var isUp = false;
var isDown = false;

// add event when the user press a key
document.addEventListener('keydown', (event) => {
    // switch through the keyboard keys we are interested in
    switch (event.code) {
        case 'ArrowLeft':
            doTeleportation(true); // single key press --> go back
            break
        case 'ArrowRight':
            doTeleportation(false); // single key press --> go forward
            break;
        case 'KeyA':
            isRotateLeft=true;
            break
        case 'KeyD':
            isRotateRight=true;
            break
        case 'KeyW':
            isRotateUp=true;
            break
        case 'KeyS':
            isRotateDown=true;
            break
        case 'ShiftLeft':
            isUp=true;
            break
        case 'Space':
            isDown=true;
            break
    }
}, false);

// add event when the user releases a key
document.addEventListener('keyup', (event) => {
    // switch through the keyboard keys we are interested in
    switch (event.code) {
        case 'KeyA':
            isRotateLeft=false;
            break
        case 'KeyD':
            isRotateRight=false;
            break
        case 'KeyW':
            isRotateUp=false;
            break
        case 'KeyS':
            isRotateDown=false;
            break
        case 'ShiftLeft':
            isUp=false;
            break
        case 'Space':
            isDown=false;
            break
    }
}, false);

// var to save the movements speed
var moveDistance = 50 * 0.2;
var rotateAngle = Math.PI / 2 * 0.01;

/**
 * checks every control key to know if it's pressed. If that's the case, move the camera accordingly
 */
function updateMovements(){
    if(isRotateLeft){
        camera.rotation.y += rotateAngle;
    }
    if(isRotateRight){
        camera.rotation.y -= rotateAngle;
    }
    if(isRotateUp){
        camera.rotation.x += rotateAngle;
    }
    if(isRotateDown){
        camera.rotation.x -= rotateAngle;
    }
    if(isUp){
        cameraPosition.y -= moveDistance;
        cameraHeight -= moveDistance;
    }
    if(isDown){
        cameraPosition.y += moveDistance;
        cameraHeight += moveDistance;
    }
}

let cameraPosition = camera.position; // var to hold the position of the camera where it's supposed to be
// --> used for the animation

/**
 * calculate the new marker to teleport into. loops if the last marker is reached
 * @param isLeft if the direction of the new marker is backwards or forwards
 */
function doTeleportation(isLeft){
    if(isLeft){
        // we are going backwards
        currentMarkerId--;
        if(currentMarkerId<0) currentMarkerId = markers.length-1;
    }else{
        // we are going forwards
        currentMarkerId++;
        if(currentMarkerId==markers.length) currentMarkerId=0;
    }
    teleport(currentMarkerId); // start the teleportation
}
let cameraHeight = 20; // custom camera height to let the user change it

/**
 * generate a new position for the camera. this is what creates the animation of teleportation
 * @param markerId
 */
function teleport(markerId){
    currentMarkerId = markerId;
    const target = markers[markerId].position.clone(); // copy the target position
    target.y = target.y + cameraHeight; // add the custom camera height
    target.x = target.x + 0.1; // slightly offsets the position as to not cause problem
    cameraPosition = target; // set the new target position
}

/**
 * interpolate the camera position into a target position
 */
function makeTransition(){
    camera.position.lerp(cameraPosition, 0.1);
}
// ============ END controls system ==============

// ============== object highlight ================
let mouse = new THREE.Vector2(); // the position of the mouse
let currentObjectPointed; // the last object pointed at
let oldColor = 0xffffff; // the initial color of the object pointed at

// add listener on mouse movement to detect if it points at an object in the scene
document.addEventListener('mousemove', (event) => {
    // get the position of the mouse
    mouse.x = ( event.clientX / window.innerWidth ) * 2 - 1;
    mouse.y = - ( event.clientY / window.innerHeight ) * 2 + 1;
    var vector = new THREE.Vector3(mouse.x, mouse.y, 1);
    vector.unproject(camera);
    // cast a vector to detect the object that the mouse points at
    var raycaster = new THREE.Raycaster( camera.position, vector.sub(camera.position).normalize() );
    var intersects = raycaster.intersectObjects(scene.children, true);
    if (intersects.length > 0) {
        // we have detected a collision
        if (currentObjectPointed != intersects[0].object) {
            // the object colliding is different than the previous one
            if (currentObjectPointed){
                // reset color of last pointed object
                currentObjectPointed.material.color.set( oldColor );
            }
            currentObjectPointed = intersects[0].object;
            oldColor = currentObjectPointed.material.color.getHex(); // save the color of the current object
            document.getElementById("current-object").innerHTML = currentObjectPointed.name; // write the name
            currentObjectPointed.material.color.set( 0x808080); // set a new color
        }
    } else {
        // we are not colliding with any object --> reset colors
        if (currentObjectPointed) currentObjectPointed.material.color.set( oldColor);
        currentObjectPointed = null;
    }
})
// ============ END object highlight ==============



// ============== start program ================
// create the renderer of Three.js --> generate what to show
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))



/**
 * main function of the program. This is what allows the program to refresh what is shown in the scene
 */
function animate() {
    requestAnimationFrame(animate);
    updateMovements(); // generate new position
    renderer.render(scene, camera); // refresh the scene
    makeTransition(); // interpolate the camera position
}

animate(); // start the program
// ============ END start program ==============
